import { AxModal, AxDropdown, IAxDropdownOptions, AxFormValidation, AxInput, IAxFormValidationOptions } from "@axess/limestone";
import * as models from "../../Rental/RiderDetails/RiderDetailsModelBundle";
import { AxStaticConfigModule } from "../../AxConfig/AxStaticConfigModule";
import { ConfigHelper, ConfigDefinition } from "../../../Lib/Helper/Config/ConfigHelper";
import { MaskedTextChangedListener } from 'ts-input-mask';
import { Subject } from "rxjs";

export class PersonDataForm {
    private formName = '#personDataForm';

    private unitSystem: number;

    private heightDropDown = new AxDropdown();
    private weightDropDown = new AxDropdown();
    private shoeSizeDropDown = new AxDropdown();
    private shoeSizeSystemDropDown = new AxDropdown();

    private countryDropDown = new AxDropdown();
    private genderDropDown = new AxDropdown();
    private skillLevelDropDown = new AxDropdown();

    private reloadSubject: Subject<models.RiderData>;

    constructor(unitSystem: number) {
        this.unitSystem = unitSystem;
    }

    async initInputsAsync(riderData: models.RiderData) {
        return new Promise<void>((resolve) => {
            this.initInputValidation();
            this.initUnitSelectionRadios(riderData);
            this.reloadSubject = new Subject<models.RiderData>();

            ConfigHelper.getBoolConfigValueAsync(ConfigDefinition.RentalDataTextInput)
                .then(async useTextInput => {
                    this.initTextInputs(riderData, useTextInput);
                    this.initDropDowns(riderData, useTextInput);
                    await this.setValueFromProductAndRiderDetailsToForm(riderData, useTextInput);
                    resolve();
                });
        });
    }

    public getReloadSubject() {
        return this.reloadSubject;
    }

    private initInputValidation() {
        let validationFormOptions = {
            selector: '#personDataForm',
            rules: this.getValidationRules(),
            callback: (form: HTMLElement) => {
                //this.submitPersonDataForm();
            }
        }

        let form = document.getElementById('personDataForm');

        let inputs = form.getElementsByClassName("ax-form-control");

        new AxFormValidation(validationFormOptions).init();

        for (let i = 0; i < inputs.length; i++) {
            let input = inputs.item(i) as HTMLInputElement;

            if (input.id.length === 0) {
                continue;
            }

            new AxInput('#' + input.id).init();
        }
    }

    private initUnitSelectionRadios(riderData: models.RiderData) {
        const radios: NodeListOf<HTMLInputElement> = document.querySelectorAll('input[name="unit"]');

        radios.forEach(radio => {
            radio.addEventListener('change', (event) => {
                const selectedVal = $(event.currentTarget).val();
                riderData.unitSystem = Number(selectedVal);
                this.reloadSubject.next(riderData);
            });
        });
    }

    private initTextInputs(riderData: models.RiderData, useTextInput: boolean) {
        if ($('#City').length > 0) {
            $('#City').on('input', e => {
                riderData.city = $('#City').val().toString();
            });
        }

        if ($('#Phone').length > 0) {
            $('#Phone').on('input', e => {
                riderData.phone = $('#Phone').val().toString();
            });
        }

        if ($('#State').length > 0) {
            $('#State').on('input', e => {
                riderData.state = $('#State').val().toString();
            });
        }

        if ($('#Street').length > 0) {
            $('#Street').on('input', e => {
                riderData.street = $('#Street').val().toString();
            });
        }

        if ($('#ZipCode').length > 0) {
            $('#ZipCode').on('input', e => {
                riderData.zipCode = $('#ZipCode').val().toString();
            });
        }

        if (useTextInput) {
            if (this.unitSystem === 1) // imperial == 1
            {
                if ($('#heightFeet').length > 0) {
                    $('#heightFeet').on('input', e => {
                        riderData.height = Number(this.getInchesToMeters());
                    });
                }

                if ($('#heightInch').length > 0) {
                    $('#heightInch').on('input', e => {
                        riderData.height = Number(this.getInchesToMeters());
                    });
                }

                if ($('#Weight').length > 0) {
                    $('#Weight').on('input', e => {
                        const weightInLbs = Number($('#Weight').val().toString());
                        riderData.weight = this.lbsToKg(weightInLbs);
                    });
                }
            } else {
                if ($('#Height').length > 0) {
                    $('#Height').on('input', e => {
                        const heightInMeter = Number($('#Height').val().toString());
                        riderData.height = heightInMeter * 100;
                    });
                }

                if ($('#Weight').length > 0) {
                    $('#Weight').on('input', e => {
                        riderData.weight = Number($('#Weight').val().toString());
                    });
                }
            }
        }
    }

    private kgToLbs(kg: number): number {
        const lbs = kg * 2.2046;
        return lbs;
    }

    private lbsToKg(lbs: number): number {
        return lbs * 0.45359237;
    }

    private metersToInches(meters: number): number {
        const inches = meters * 39.37;
        return inches;
    }

    private getInchesToMeters(): number {
        const inches = this.getHeightInches();
        const meters = inches / 39.370;
        return meters;
    }

    private getHeightInches() {
        let feet = $('#heightFeet').val();
        let inches = $('#heightInch').val();

        let convertedInches = this.convertFeetAndInchesToInches(feet, inches);
        return convertedInches;
    }

    private convertFeetAndInchesToInches(feet, inches) {
        // Convert feet to inches by multiplying by 12
        let totalInches = feet * 12;
        // Add the remaining inches
        totalInches += inches;
        // Return the total inches
        return totalInches;
    }

    private initDropDowns(riderData: models.RiderData, useTextInput: boolean) {
        this.initCountryDropDown(riderData);
        this.initGenderDropDown(riderData);
        this.initSkillLevelDropDown(riderData);
        this.initShoeSizeSystemDropDown(riderData);
        this.initShoeSizeDropDown(riderData);

        if (!useTextInput) {
            this.initHeightDropDown(riderData);
            this.initWeightDropDown(riderData);
        }
    }

    private async setValueFromProductAndRiderDetailsToForm(riderData: models.RiderData, useTextInput: boolean) {
        return new Promise<void>((resolve) => {

            if ($('#City').length > 0) {
                $('#City').val(riderData.city);
                $('#City').text(riderData.city);
            }

            if ($('#Phone').length > 0) {
                $('#Phone').val(riderData.phone);
                $('#Phone').text(riderData.phone);
            }

            if ($('#State').length > 0) {
                $('#State').val(riderData.state);
                $('#State').text(riderData.state);
            }

            if ($('#Street').length > 0) {
                $('#Street').val(riderData.street);
                $('#Street').text(riderData.street);
            }

            if ($('#ZipCode').length > 0) {
                $('#ZipCode').val(riderData.zipCode);
                $('#ZipCode').text(riderData.zipCode);
            }

            if (useTextInput) {
                if (this.unitSystem === 1) {

                    if (riderData.height != undefined || riderData.height != null) {

                        const heightInInches = this.metersToInches(riderData.height / 100);

                        let feet = Math.floor(heightInInches / 12);
                        let inches = heightInInches % 12;

                        $('#heightFeet').val(feet);
                        $('#heightFeet').text(feet);

                        $('#heightInch').val(inches.toFixed(2));
                        $('#heightInch').text(inches.toFixed(2));
                    }

                    if (riderData.weight != undefined || riderData.weight != null) {

                        let weightInLbs = this.kgToLbs(riderData.weight);
                        let weight = parseFloat(weightInLbs.toFixed(2));
                        $('#Weight').val(weight);
                        $('#Weight').text(weight);
                    }
                } else {
                    if ($('#Height').length > 0) {

                        let height = riderData?.height;

                        this.applyMeterMask($('#Height')[0] as HTMLInputElement);

                        $('#Height').val(height);
                        $('#Height').text(height);
                    }

                    if ($('#Weight').length > 0) {

                        let weight = riderData.weight;

                        if (weight != undefined || weight != null) {
                            weight = parseFloat(weight.toFixed(2));
                        }

                        $('#Weight').val(weight);
                        $('#Weight').text(weight);
                    }
                }
            }

            resolve();
        });
    }

    hasForm(): boolean {
        if ($(this.formName).length === 0) {
            return false;
        } else {
            return true;
        }
    }

    formIsValid(): boolean {
        let valid = $(this.formName)?.valid();
        return valid;
    }

    setEmptyValues(riderData: models.RiderData) {
        riderData = new models.RiderData();
        riderData.customerName = "name";
        riderData.customerEmail = "mail";
    }

    private initShoeSizeSystemDropDown(riderData: models.RiderData) {
        if ($('.rental_customer_details-shoeSizeSystem').length === 0) {
            return;
        }

        this.shoeSizeSystemDropDown = new AxDropdown();
        this.shoeSizeSystemDropDown.init(`.rental_customer_details-shoeSizeSystem`,
            {
                searchBar: false,
                multiSelect: false,
                onOpen: () => {

                },
                onSelect: (elem: any) => {
                    try {
                        const value = this.shoeSizeSystemDropDown.getValue().toString();
                        if (riderData.shoeSizeSystem !== Number(value)) {
                            riderData.shoeSizeSystem = Number(value);
                            this.reloadSubject.next(riderData);
                        }
                    } catch (e) {

                    }
                }
            });

        if (riderData.shoeSizeSystem != undefined || riderData.shoeSizeSystem != null) {
            this.shoeSizeSystemDropDown.setValue(riderData.shoeSizeSystem.toString());
        }
    }

    private initHeightDropDown(riderData: models.RiderData) {
        if ($('.rental_customer_details-height').length === 0) {
            return;
        }

        this.heightDropDown = new AxDropdown();
        this.heightDropDown.init(`.rental_customer_details-height`,
            {
                searchBar: false,
                multiSelect: false,
                onOpen: () => {

                },
                onSelect: (elem: any) => {
                    try {
                        const value = this.heightDropDown.getValue().toString();
                        $('#Height').val(value);
                        riderData.height = Number(value);
                    } catch (e) {

                    }
                }
            });

        if (riderData.height != undefined || riderData.height != null) {
            this.heightDropDown.setValue(riderData.height.toString());
        }
    }

    private initShoeSizeDropDown(riderData: models.RiderData) {
        if ($('.rental_customer_details-shoeSize').length === 0) {
            return;
        }

        this.shoeSizeDropDown = new AxDropdown();
        this.shoeSizeDropDown.init(`.rental_customer_details-shoeSize`,
            {
                searchBar: false,
                multiSelect: false,
                onOpen: () => {

                },
                onSelect: (elem: any) => {
                    try {
                        const value = this.shoeSizeDropDown.getValue().toString();
                        $('#ShoeSize').val(value);
                        riderData.shoeSize = Number(value);
                    } catch (e) {

                    }
                }
            });

        if (riderData.shoeSize != undefined || riderData.shoeSize != null) {
            this.shoeSizeDropDown.setValue(riderData.shoeSize.toString());
        }
    }

    private initWeightDropDown(riderData: models.RiderData) {
        if ($('.rental_customer_details-weight').length === 0) {
            return;
        }

        this.weightDropDown = new AxDropdown();
        this.weightDropDown.init(`.rental_customer_details-weight`,
            {
                searchBar: false,
                multiSelect: false,
                onOpen: () => {

                },
                onSelect: (elem: any) => {
                    try {
                        const value = this.weightDropDown.getValue().toString();
                        $('#Weight').val(value);
                        riderData.weight = Number(value);
                    } catch (e) {

                    }
                }
            });

        if (riderData.weight != undefined || riderData.weight != null) {
            this.weightDropDown.setValue(riderData.weight.toString());
        }
    }

    private initCountryDropDown(riderData: models.RiderData) {
        if ($('.rental_customer_details-country').length === 0) {
            return;
        }

        this.countryDropDown = new AxDropdown();
        this.countryDropDown.init(`.rental_customer_details-country`,
            {
                searchBar: false,
                multiSelect: false,
                onOpen: () => {

                },
                onSelect: (elem: any) => {
                    const value = this.countryDropDown.getValue().toString();
                    $('#CustomerCountry').val(value);
                    riderData.country = value;
                }
            });

        if (riderData.country != undefined || riderData.country != null) {
            this.countryDropDown.setValue(riderData.country);
        }
    }

    private initGenderDropDown(riderData: models.RiderData) {
        if ($('.rental_customer_details-gender').length === 0) {
            return;
        }

        this.genderDropDown = new AxDropdown();
        this.genderDropDown.init(`.rental_customer_details-gender`,
            {
                searchBar: true,
                multiSelect: false,
                onOpen: () => {

                },
                onSelect: (elem: any) => {
                    const value = this.genderDropDown.getValue().toString();
                    $('#Gender').val(value);
                    riderData.gender = value;
                }
            });

        if (riderData.gender != undefined || riderData.gender != null) {
            this.genderDropDown.setValue(riderData.gender);
        }
    }

    private initSkillLevelDropDown(riderData: models.RiderData) {
        if ($('.rental_customer_details-skillLevel').length === 0) {
            return;
        }

        this.skillLevelDropDown = new AxDropdown();
        this.skillLevelDropDown.init(`.rental_customer_details-skillLevel`,
            {
                searchBar: false,
                multiSelect: false,
                onOpen: () => {

                },
                onSelect: (elem: any) => {
                    const value = this.skillLevelDropDown.getValue().toString();
                    $('#SkillLevel').val(value);
                    riderData.skillLevel = Number(value);
                }
            });

        if (riderData.skillLevel != undefined || riderData.skillLevel != null) {
            this.skillLevelDropDown.setValue(riderData.skillLevel.toString());
        }
    }

    private getValidationRules(): JQueryValidation.RulesDictionary {
        const that = this;
        return {
            hiddenPhone: {
                required: true,
                regex: /([0-9]{10})|(\([0-9]{3}\)\s+[0-9]{3}\-[0-9]{4})/
            },
            phone: {
                required: true,
                regex: /([0-9]{10})|(\([0-9]{3}\)\s+[0-9]{3}\-[0-9]{4})/,
                normalizer: function (value) {
                    let dropdownVal = $(this).parents(".ax-phone-field").find(".hidden-input").val() as string;
                }
            },
            email: {
                required: true,
                email: true,
                regex: /^\b[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}\b$/i,
            }
        };
    }

    applyMeterMask(inputElement: HTMLInputElement) {
        const meterFormat = "[0].[00]";
        //const feetAndInchesFormat = '9999\'99"';

        const listener = MaskedTextChangedListener.installOn(meterFormat, inputElement,
            new class implements MaskedTextChangedListener.ValueListener {
                public onTextChanged(maskFilled: boolean, extractedValue: string, formattedText: string): void {
                    console.log(maskFilled, extractedValue, formattedText);
                }
            }(),
            [], // affineFormats
            [], // customNotations
            null, // affinityCalculationStrategy
            true // autocomplete
        );
    }

    applyFeetAndInchesMask(inputElement: HTMLInputElement) {
        const feetAndInchesFormat = "[00]' [00]''";
        //const feetAndInchesFormat = '9999\'99"';

        const listener = MaskedTextChangedListener.installOn(feetAndInchesFormat, inputElement,
            new class implements MaskedTextChangedListener.ValueListener {
                public onTextChanged(maskFilled: boolean, extractedValue: string, formattedText: string): void {
                    console.log(maskFilled, extractedValue, formattedText);
                }
            }(),
            [], // affineFormats
            [], // customNotations
            null, // affinityCalculationStrategy
            true // autocomplete
        );
    }
}